export enum LeagueTableFilters {
  RegionType = "regionType",
  CountryCode = "countryCode",
}
